var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"var(--primary)","display":"flex","flex-direction":"column","align-items":"center","padding-bottom":"50px"}},[_c('ImageContainer',{staticClass:"mwidth",attrs:{"imagens":_vm.imagens}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }